export default {
  name: 'Highlight',
  components: {},
  props: ['text', 'highlight'],
  data() {
    return {};
  },
  computed: {
    processed() {
      let processed = this.text;
      if (this.highlight.length) {
        this.highlight.map(current => {
          var escaped = current.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
          var regexp = new RegExp(escaped, 'ig');
          processed = processed.replace(
            regexp,
            '<span class="highlight">$&</span>'
          );
        });
      }

      return processed;
    }
  },
  mounted() {},
  methods: {}
};
